import React, { FC, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export const SheetFooter: FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
  <div className={twMerge('flex flex-col-reverse', className)} {...props} />
);
SheetFooter.displayName = 'SheetFooter';
